import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function RubricasIcon({ className }: IconProps) {
  return (
    <svg
      width="113"
      height="73"
      viewBox="0 0 113 73"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2282)">
        <path
          d="M65.4222 73V11.5926C61.8847 10.1131 55.5708 3.17967 53.6677 0H3.35843C1.5001 0 0 1.47943 0 3.31216V64.1234C0 69.0254 4.03012 73 9.00059 73H65.4222Z"
          fill="#EAEEF9"
        />
        <path
          d="M9.1123 73.0001C13.4559 73.0001 17.0606 69.8205 17.6203 65.6913C17.7099 65.0289 18.2696 64.521 18.9413 64.521H72.5195C73.3703 64.521 73.9972 65.2718 73.8405 66.0888C73.1016 70.0192 69.5864 73.0001 65.3772 73.0001H9.1123Z"
          fill="#00C4B3"
        />
        <path
          d="M32.7113 14.3304H6.82903C6.31407 14.3304 5.88867 13.9109 5.88867 13.403C5.88867 12.8951 6.31407 12.4756 6.82903 12.4756H32.7113C33.2263 12.4756 33.6517 12.8951 33.6517 13.403C33.6517 13.9109 33.2263 14.3304 32.7113 14.3304Z"
          fill="#00416B"
        />
        <path
          d="M20.7553 21.7498H6.82903C6.31407 21.7498 5.88867 21.3303 5.88867 20.8224C5.88867 20.3146 6.31407 19.895 6.82903 19.895H20.7777C21.2927 19.895 21.7181 20.3146 21.7181 20.8224C21.7181 21.3303 21.2927 21.7498 20.7777 21.7498"
          fill="#00416B"
        />
        <path
          d="M17.0834 29.0809H6.82903C6.31407 29.0809 5.88867 28.6613 5.88867 28.1535C5.88867 27.6456 6.31407 27.2261 6.82903 27.2261H17.1058C17.6208 27.2261 18.0462 27.6456 18.0462 28.1535C18.0462 28.6613 17.6208 29.0809 17.1058 29.0809"
          fill="#00416B"
        />
        <path
          d="M57.8096 58.89H28.8823C27.9419 58.89 27.1807 58.1393 27.1807 57.2119C27.1807 56.2844 27.9419 55.5337 28.8823 55.5337H57.8096C58.7499 55.5337 59.5335 56.2844 59.5335 57.2119C59.5335 58.1393 58.7723 58.89 57.8096 58.89Z"
          fill="#00416B"
        />
        <path
          d="M53.6455 0L65.4 11.5926H55.4591C54.4515 11.5926 53.6455 10.7976 53.6455 9.80399V0Z"
          fill="#00416B"
        />
        <path
          d="M108.768 10.9962L104.29 6.58003C103.462 5.76304 102.141 5.76304 101.313 6.58003L61.3472 45.9947C60.9442 46.3922 60.9442 47.0546 61.3472 47.4742L67.3028 53.3477C67.7058 53.7452 68.3775 53.7452 68.8029 53.3477L108.768 13.933C109.597 13.116 109.597 11.8132 108.768 10.9962Z"
          fill="#00C4B3"
        />
        <path
          d="M105.545 17.113L98.0889 9.76001C97.9546 9.62752 97.7307 9.62752 97.5964 9.76001L95.6037 11.7252C95.4693 11.8577 95.4693 12.0785 95.6037 12.211L103.059 19.564C103.194 19.6965 103.418 19.6965 103.552 19.564L105.545 17.5988C105.679 17.4663 105.679 17.2455 105.545 17.113Z"
          fill="#00416B"
        />
        <path
          d="M100.574 22.0149L93.1182 14.6619C92.9839 14.5294 92.76 14.5294 92.6256 14.6619L90.633 16.6271C90.4986 16.7596 90.4986 16.9804 90.633 17.1129L98.0887 24.4659C98.223 24.5983 98.4469 24.5983 98.5813 24.4659L100.574 22.5006C100.708 22.3682 100.708 22.1473 100.574 22.0149Z"
          fill="#00416B"
        />
        <path
          d="M82.9539 39.3928L75.4982 32.0398C75.3639 31.9073 75.14 31.9073 75.0056 32.0398L61.1017 45.7521C60.6987 46.1496 60.6763 46.812 61.1017 47.2316L67.5499 53.5909C67.9529 53.9884 68.6246 53.9884 69.05 53.5909L82.9539 39.8786C83.0882 39.7461 83.0882 39.5253 82.9539 39.3928Z"
          fill="#00416B"
        />
        <path
          d="M67.5719 53.5908L61.1237 47.2314L56.6682 56.4834C56.2204 57.4329 57.2279 58.4265 58.1907 57.9849L67.5719 53.5908Z"
          fill="#00C4B3"
        />
        <path
          d="M112.486 4.87997L110.493 2.91475C109.799 2.23024 108.702 2.23024 108.008 2.91475L104.291 6.58021L108.769 10.9964L112.486 7.33096C113.18 6.64645 113.18 5.56448 112.486 4.87997Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2282">
          <rect width="113" height="73" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
